import request from '@/utils/request'
import { getToken } from '@/utils/auth'
import Cookies from 'js-cookie'

export function getList (filters = {}, pagination = {}) {
  const is_show_closed_protocol = parseInt(Cookies.get('is_show_closed_protocol'))
  //TODO vecchio url (/adverse_event) per recuperare tutti gli AE senza filtro per protocol Closed
  return request({
    url: `/list/adverse_event/${is_show_closed_protocol}`,
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination),
      'X-query-debug' : false
    }
  })
}

export function getDetail (id) {
  return request({
    url: '/adverse_event/' + id,
    method: 'get'
  })
}

export function nextCin (data) {
  return request({
    url: '/next_cin/ae',
    method: 'post',
    data,
  })
}

export function meddra (term) {
  return request({
    url: '/meddra/' + term,
  })
}

export function meddraById (id) {
  return request({
    url: '/meddra/id/' + id,
  })
}


export function getSocs (id) {
  return request({
    url: '/meddra/getSocs/' + id,
  })
}

export function notifyAE (data) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  const promise = request({
    url: '/notify/ae/' + data.id,
    method: 'post',
    data
  })
  promise.finally( e => { request.defaults.timeout = 5000;})
  return promise;
}

export function upsert (data) {
  var method = 'post'
  var url = '/adverse_event'
  if (data.id) {
    method = 'put'
    url = '/adverse_event/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (id) {
  return request({
    url: '/adverse_event/' + id,
    method: 'delete',
  })
}

export function uploadPdf (data) {

  request.defaults.timeout = request.timeoutrequest; //issue 658
  const promise = request({
    url: '/pdf/ae/' + data.get('id'),
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  promise.finally( e => { request.defaults.timeout = request.timeoutrequest;}) //issue 658
  return promise;
}

export function removePdf (id) {
  return request({
    url: '/remove_pdf/ae/' + id,
    method: 'post'
  })
}

export function updatePdfName (id) {
  return request({
    url: '/update_pdf_filename/' + id,
    method: 'post',
  })
}

export function downloadPdf (id, type, filename, download = true) {
  return request({
    url: '/pdf/ae/' + type + '/' + id,
    method: 'get',
    responseType: 'blob',
  }).then( response => {

      var newBlob = new Blob([response.data], {type: "application/pdf"});
      var fileURL = window.URL.createObjectURL(newBlob, { oneTimeOnly: true });
      
      if(download) {
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);
        fileLink.click();
      }

      return fileURL
      // let tab = window.open(); 
      // tab.location.href = fileURL;

  })
}

export function causalityPdf (id) {

  return request({
    url: '/adverse_event/' + id + '/causality_pdf',
    method: 'get',
    responseType: 'blob',
  }).then( response => {
      const filename = response.headers.get("X-Filename")
      var newBlob = new Blob([response.data], {type: "application/pdf"});
      var fileURL = window.URL.createObjectURL(newBlob, { oneTimeOnly: true });
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
      return fileURL
  })

}

export function duplicate (id) {
  return request({
    url: '/adverse_event/' + id + '/duplicate',
    method: 'post',
  })
}

export function searchCausalityByCin(id) {
  return request({
    url: '/adverse_event/' + id + '/causality',
    method: 'get',
  })
}

export function importMultipleSae(rows) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  const promise = request({
    url: '/import/adverse_event',
    method: 'post',
    data: {
      data: rows
    }
  })
  promise.finally( e => { request.defaults.timeout = request.timeoutrequest;}) //issue 658
  return promise;
}

export function getSeriousCriterias () {
  return ['Death', 'Life Threatening', 'Hospitalization required or prolonged', 'Congenital anomaly or Birth Defect', 'Significant or Persistent disability', 'Other Medically Important Event', 'AESI', 'Special Situation', 'Liver stopping event']
}